import React from 'react'
import ReactApexChart from 'react-apexcharts';
import { registerLocale } from  "react-datepicker";
import pl from 'date-fns/locale/pl';
import {useNavigate} from "react-router-dom";
import plApex from "apexcharts/dist/locales/pl.json";

const RaportVisualization = (props) => {
  const valueConvert = (val) => {
    return Number(val).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",")
  }
  const { active, dataChart } = props.data?props.data:props;
  const startData = props.startData?props.startData:null;
  const endData = props.endData?props.endData:null;
  const opkNumber = props.opkNumber?props.opkNumber:null;
  registerLocale('pl', pl)
  const navigate = useNavigate();

  const colorPalette = ["#0093cf", '#feda04','#00b882','#fe8622',"#59ade1",'#750046','#00979c','#ff6d32',"#004a74",
  "#EAB200",'#eb6b6b','#88d14c','#18738e',"#FFE07D","#686868","#cb0026","#6B6BCF",'#0ddcc2',"#006ba7",'#ffb700','#40e1fe',
  "#2A6468",'#00c0d1',"#A3A3E0",'#3889a2','#ffb061','#8f98cd','#ffe07d']
  const dataLabelStyle = { fontSize: '12px', colors: ["#263238"], fontFamily: "Montserrat, Helvetica Neue", fontWeight: 400 }
  const titleStyle = {
    fontSize:  '14px',
    fontWeight: 600,
    fontFamily: "Montserrat, Helvetica Neue",
    color:  '#263238'
  }
  const treemapColor = (opk) => {
    let color = '#72b6e5' //500-508
    if (Number(opk)>519) color='#6976bc' //520-529
    if (Number(opk)===507) color='#5b93de'
    if (Number(opk)===530) color='#42a0ba'
    if (Number(opk)===535) color='#86d1cd'
    if (Number(opk)===540) color='#2a76aa'
    if (Number(opk)===545) color='#1f7993'
    if (Number(opk)===550) color='#b6b6b6'
    return color
  }

  const shuffleArray = arg => {
    let array = arg
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array
  }
  const getChartData = () =>{
    let data ={
      series: [],
      options: {
        chart: {
          height: 500,
          type: 'pie',
        }, 
        colors : colorPalette,
        xaxis:{categories:[]} },
    };
    if(dataChart&&Object.getOwnPropertyNames(dataChart).length !== 0){
      let series, values, categories, colNamesDict
      switch(active){
        case 0:
          data.series = [ { data: [] } ];
          data.options = {
            plotOptions: {
              treemap: {
                distributed: true,
                enableShades: false
              }
            },
            legend: { show: false },
             title: {
              text: "Zestawienie kosztów całkowitych OPK według rodzajów działalności " +( startData?(" od "+( new Date(startData).getMonth()+1)+"/"+new Date(startData).getFullYear()) : "") +( endData?(" do "+( new Date(endData).getMonth()+1)+"/"+new Date(endData).getFullYear()) : ""),
              align: 'center',
              margin: 10,
              offsetX: 0,
              offsetY: 0,
              floating: false,
              style: titleStyle,
          },
          dataLabels: {
            style: {...dataLabelStyle, colors:['white'], fontSize: '14px'}
          },
            chart: {
              height: 1000,
              type: 'treemap',
              // title: { text: 'Basic Treemap' }
              events: {
                dataPointSelection: function (event, chartContext, config) {
                  // The last parameter config contains additional information like `seriesIndex` and `dataPointIndex` for cartesian charts
                  localStorage.setItem('activeOPKforManagement', Object.keys(dataChart)[config.dataPointIndex]);
                  localStorage.setItem('activeOPKforManagementName', dataChart[Object.keys(dataChart)[config.dataPointIndex]]['name']);
                  navigate('/admin/management_dashboard')
                }
              }
            },
            colors: ['#5b93de'],
            tooltip:{
              followCursor: true,
              custom: function({series, seriesIndex, dataPointIndex, w}) {
                let opk = Object.keys(dataChart)[dataPointIndex]
                let tooltip = '<div class="arrow-box" style="padding: 5px; font-size:10px ">'
                tooltip+='<div style="padding: 3px; font-weight: bold;">'
                tooltip+=opk+' '+dataChart[opk]['name']+'</div><div >'
                tooltip+='Koszt całkowity OPK: '+valueConvert(dataChart[opk]['KOSZT CAŁKOWITY OPK [ZŁ]'])+' zł<br>'
                tooltip+='Udział procentowy kosztu: '+dataChart[opk]['KOSZT CAŁKOWITY OPK [ZŁ]_p'].toString().replace(".",",")+' %'
                tooltip+= '</div></div>'
                return tooltip
              }
            },
          };
          var newSeries =[]
          var colors = [], valueTemp
          Object.entries(dataChart).map(([key, value],i)=>{
              if(key!=='Suma Kosztów wszystkich OPK') {
                valueTemp = 0
                // if(value['KOSZT CAŁKOWITY OPK [ZŁ]']===0){valueTemp = 0.5}
                // else if(value['KOSZT CAŁKOWITY OPK [ZŁ]_p']<1 && value['KOSZT CAŁKOWITY OPK [ZŁ]']!==0){valueTemp = 1}
                // else{valueTemp = value['KOSZT CAŁKOWITY OPK [ZŁ]_p']}
                if(value['KOSZT CAŁKOWITY OPK [ZŁ]_p']===0){valueTemp = 0.5}
                else{valueTemp = Math.ceil(value['KOSZT CAŁKOWITY OPK [ZŁ]_p']/10)}
                newSeries.push({x:key, y:valueTemp})
                colors.push(treemapColor(key.split('-')[0]))
                // data.options.colors.push(treemapColor((key.split('-')[0])))
              }
          })
          data.series[0].data = newSeries
          data.options.colors=colors
          break;
        case 1: 
          data.options= {
            chart: {
              type: 'bar',
              height: 500,
              stacked: true,
              stackType: '100%'
            },
            plotOptions: { bar: { horizontal: true } },
            dataLabels: {
              formatter: function (val, opt) {
                return val?val.toFixed()+'%':''
              },
              style: dataLabelStyle
            },
            xaxis:{categories:[]},
            legend: {
              position: 'top',
              horizontalAlign: 'center',
              offsetX: 40,
              offsetY: -40,
              floating: true,
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return val.toFixed(2)
                }
              }
            }
          }
          if(Object.keys(dataChart).length>8) data.options.chart.height = 500 + (Object.keys(dataChart).length-8)*30
          series = Object.keys(dataChart[Object.keys(dataChart)[0]])
          series = series.filter(function(e) { return e !== 'children'&&e !== 'name' })

          values = {}
          series.forEach(val => {
            values[val] = []
          })
          Object.entries(dataChart).map(([opk, item], i)=>{
            if(opk!=="Suma Kosztów wszystkich OPK"){
            series.forEach(val => {
              values[val].push(Number(item[val]))
            })}
          })
          series.forEach(val=>{
            data.series.push({
              name: val,
              data: values[val]
            })
          })

          data.options.xaxis.categories = Object.keys(dataChart)
          break;
        case 2:
          data.options= {
            chart: {
              type: 'bar',
              height: 500,
              stacked: true,
              stackType: '100%'
            },
            plotOptions: { bar: { horizontal: true, dataLabels: {hideOverflowingLabels: false} } },
            dataLabels: {
              formatter: function (val, opt) {
                return val?valueConvert(val)+'%':''
              },
              style: {...dataLabelStyle, colors: ['white']}
            },
            xaxis:{
              categories:[],
              showAlways: true,
              labels:{ maxHeight: 500},
              opposite:true
            },
            yaxis:{
              showAlways: true,
              // max: 
              // opposite:true
            },
            legend: {
              position: 'top',
              horizontalAlign: 'center',
              // offsetX: 40,
              // offsetY: -10,
              // floating: true,
            },
            tooltip:{
              followCursor: true,
              shared: false,
              custom: function({seriesIndex, dataPointIndex}) {
                let key = ["dir_cost","indir_cost","procedural_cost","manag_cost"]
                let element = dataChart[dataPointIndex]
                let series = key[seriesIndex]
                let valTypeDict = {
                  "dir_cost":"Wartość kosztów bezpośrednich: ",
                  "indir_cost":"Wartość kosztów pośrednich działalności pomocniczej <br>medycznej i niemedycznej: ",
                  "procedural_cost":"Wartość kosztów pośrednich OPK <br>proceduralnych: ",
                  "manag_cost":"Wartość kosztów zarządu: "
                }
                let tooltip = '<div class="arrow-box" style="padding: 5px; font-size:10px;">'
                tooltip+='<div style="padding: 3px; font-weight: bold; ">'+element.name+'</div>'
                tooltip+='<div>'
                tooltip+=valTypeDict[series]+valueConvert(element[series])+' zł<br>'
                tooltip+='Udział w koszcie całkowitym OPK: '+valueConvert(element[series+'_p'])+'%'
                tooltip+= '</div></div>'
                return tooltip
              }
            },
            colors:['#3889a2','#ffb061','#8f98cd','#ffe07d'],
            title: {
              text: "Sumaryczne zestawienie kosztów całkowitych ośrodków powstania kosztów" +( startData?(" od "+( new Date(startData).getMonth()+1)+"/"+new Date(startData).getFullYear()) : "") +( endData?(" do "+( new Date(endData).getMonth()+1)+"/"+new Date(endData).getFullYear()) : ""),
              align: 'center',
              margin: 10,
              offsetX: 0,
              offsetY: 0,
              floating: false,
              style: titleStyle,
          }
          }
          if(dataChart.length>8) data.options.chart.height = 500 + (dataChart.length-8)*30

          // let series = Object.keys(dataChart[0]).filter(el => {return el.includes('_p')})
          series = ["dir_cost","indir_cost","procedural_cost","manag_cost"]
          colNamesDict = {
            "dir_cost":"Koszty bezpośrednie [zł]",
            "indir_cost":"Koszty pośrednie działalności pomocniczej medycznej i niemedycznej [zł]",
            "procedural_cost":"Koszty pośrednie OPK proceduralnych [zł]",
            "manag_cost":"Koszty zarządu [zł]"
          }
          values = {}
          series.forEach(val => {
            values[val] = []
          })
          categories = []
          dataChart.forEach(item => {
            if(item.name!=='Wartość ogółem'){
              categories.push(item.number)
              series.forEach(val => {
                values[val].push(Number(item[val]))
              })
            }
          })
          series.forEach(val=>{
            data.series.push({
              name: colNamesDict[val],
              data: values[val]
            })
          })
          
          data.options.xaxis.categories = categories.map(cur => {
            const splitedItems = cur.trim().split(" ");
            const arrayOfSingleString = [];
            let str = "";
            while (splitedItems.length > 0) {
              const item = splitedItems.shift();
              if (str.length + item.length >= 20) {
                // trying to make a chunk
                arrayOfSingleString.push(str);
                // clearing the str because it has been pushed to arrayOfSingleString
                str = item;
              } else {
                // concat the str with curent word
                str = str ? `${str} ${item}` : item;
              }
            }
            arrayOfSingleString.push(str);
            return arrayOfSingleString;
          })
          break;
        case 3.1:
          data = {
            series : [{name: '',  data: []}],
            series1 : [{name: '',  data: []}],
            series2 : [{name: '',  data: []}],
            series3 : [{name: '',  data: []}],
            series4 : [{name: '',  data: []}],
            series5 : [{name: '',  data: []}],
            series6 : [{name: '',  data: []}],
          }
          data.options= {
            chart: {
              height: 350,
              type: 'bar',
              zoom: { enbaled: false}
            },
            plotOptions: {
              bar: {
                columnWidth: '50%',
                borderRadius: 10,
                dataLabels: {
                  position: 'top', // top, center, bottom
                },
              }
            },
            dataLabels: {
              enabled: true,
              formatter: function (val) {
                return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") + " zł";
              },
              offsetY: -20,
              style: dataLabelStyle
            },
            tooltip:{
              enabled: false,
            },
            xaxis: {
              categories: ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"],
              position: 'bottom',
              axisBorder: {
                show: false
              },
              axisTicks: {
                show: false
              },
              crosshairs: {
                fill: {
                  type: 'gradient',
                  gradient: {
                    colorFrom: '#D8E3F0',
                    colorTo: '#BED1E6',
                    stops: [0, 100],
                    opacityFrom: 0.4,
                    opacityTo: 0.5,
                  }
                }
              },
              tooltip: {
                enabled: false,
              }
            },
            yaxis: {
              axisBorder: {
                show: false
              },
              axisTicks: {
                show: false,
              },
              labels: {
                show: true,
                formatter: function (val) {
                  return (Number(val).toFixed()).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") ;
                }
              },
              title: {
                text: 'Wartość kosztu w zł',
                rotate: -90,
                offsetX: 0,
                offsetY: 0,
                style: {
                    fontSize: '12px',
                    fontWeight: 600,
                    fontFamily: "Montserrat, Helvetica Neue",
                    cssClass: 'apexcharts-yaxis-title',
                },
              },
            },
            title: {
              text: 'Zestawienie wartościowe kosztów rodzajowych - konto syntetyczne 400 Amortyzacja',
              align: 'center',
              style: titleStyle
            },
            subtitle: {
              text: ( opkNumber.hasOwnProperty("value") && opkNumber.value!== "" ?("nr OPK "+opkNumber.value ):"" ) +( startData?(" od "+( new Date(startData).getMonth()+1)+"/"+new Date(startData).getFullYear()) : "") +( endData?(" do "+( new Date(endData).getMonth()+1)+"/"+new Date(endData).getFullYear()) : ""),
              align: 'center',
              style: titleStyle
            },
            colors:['#00c0d1']
          }
          colNamesDict = {
            "1": "Styczeń", "2": "Luty", "3": "Marzec", "4": "Kwiecień", "5": "Maj", "6": "Czerwiec", 
            "7": "Lipiec", "8": "Sierpień", "9": "Wrzesień", "10": "Październik", "11": "Listopad", "12": "Grudzień"
          }
          categories=[]
          series =[]
          var series1 = [], series2 = [], series3 = [], series4 = [], series5 = [], series6 = []
          Object.entries(colNamesDict).map(([key,value],i)=>{
            if(!dataChart['400']['values'][key]){
              // series.push(0);  series1.push(0); series2.push(0); series3.push(0); series4.push(0); series5.push(0); series6.push(0)
            }
            else{
              if(Object.keys(dataChart).includes('400')) series.push(Number(dataChart['400']['values'][key].toFixed(2)))
              if(Object.keys(dataChart).includes('401')) series1.push(Number(dataChart['401']['values'][key].toFixed(2)))
              if(Object.keys(dataChart).includes('402')) series2.push(Number(dataChart['402']['values'][key].toFixed(2)))
              if(Object.keys(dataChart).includes('403')) series3.push(Number(dataChart['403']['values'][key].toFixed(2)))
              if(Object.keys(dataChart).includes('404')) series4.push(Number(dataChart['404']['values'][key].toFixed(2)))
              if(Object.keys(dataChart).includes('405')) series5.push(Number(dataChart['405']['values'][key].toFixed(2)))
              if(Object.keys(dataChart).includes('406')) series6.push(Number(dataChart['406']['values'][key].toFixed(2)))
              categories.push(colNamesDict[key]) 
            }
          })
          data.options.xaxis.categories = categories
          data.series[0].data = series
          data.series1[0].data = series1
          data.series2[0].data = series2
          data.series3[0].data = series3
          data.series4[0].data = series4
          data.series5[0].data = series5
          data.series6[0].data = series6

          data.options1 = JSON.parse(JSON.stringify(data.options))
          data.options2 = JSON.parse(JSON.stringify(data.options))
          data.options3 = JSON.parse(JSON.stringify(data.options))
          data.options4 = JSON.parse(JSON.stringify(data.options))
          data.options5 = JSON.parse(JSON.stringify(data.options))
          data.options6 = JSON.parse(JSON.stringify(data.options))
          data.options1['title']['text']="Zestawienie wartościowe kosztów rodzajowych - konto syntetyczne 401 Zużycie materiałów i energii"
          data.options1['colors']=['#eb6b6b']
          data.options1['dataLabels']={
            enabled: true,
            formatter: function (val) {
              return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") + " zł";
            },
            offsetY: -20,
            style: dataLabelStyle
          }
          data.options1['yaxis']['labels'] = {
            show: true,
            formatter: function (val) {
              return (Number(val).toFixed()).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") ;
            }}
          data.options1['tooltip']['y'] = {
            show: true,
            formatter: function(val){return val.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") + " zł"},
          }
          data.options2['title']['text']="Zestawienie wartościowe kosztów rodzajowych - konto syntetyczne 402 Usługi obce " 
          data.options2['colors']=['#006ba7']
          data.options2['dataLabels']={
            enabled: true,
            formatter: function (val) {
              return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") + " zł";
            },
            offsetY: -20,
            style: dataLabelStyle
          }
          data.options2['yaxis']['labels'] = {
            show: true,
            formatter: function (val) {
              return (Number(val).toFixed()).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") ;
            }}
          data.options2['tooltip']['y'] = {
            show: true,
            formatter: function(val){return val.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") + " zł"},
          }
          data.options3['title']['text']="Zestawienie wartościowe kosztów rodzajowych - konto syntetyczne 403 Podatki i opłaty " 
          data.options3['colors']=['#00b881']
          data.options3['dataLabels']={
            enabled: true,
            formatter: function (val) {
              return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") + " zł";
            },
            offsetY: -20,
            style: dataLabelStyle
          }
          data.options3['yaxis']['labels'] = {
            show: true,
            formatter: function (val) {
              return (Number(val).toFixed()).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") ;
            }}
          data.options3['tooltip']['y'] = {
            show: true,
            formatter: function(val){return val.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") + " zł"},
          }
          data.options4['title']['text']="Zestawienie wartościowe kosztów rodzajowych - konto syntetyczne 404 Wynagrodzenia " 
          data.options4['colors']=['#a3a3e0']
          data.options4['dataLabels']={
            enabled: true,
            formatter: function (val) {
              return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") + " zł";
            },
            offsetY: -20,
            style: dataLabelStyle
          }
          data.options4['yaxis']['labels'] = {
            show: true,
            formatter: function (val) {
              return (Number(val).toFixed()).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") ;
            }}
          data.options4['tooltip']['y'] = {
            show: true,
            formatter: function(val){return val.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") + " zł"},
          }
          data.options5['title']['text']="Zestawienie wartościowe kosztów rodzajowych - konto syntetyczne 405 Składki na rzecz (ZUS) i inne "
          data.options5['title']['style']['fontSize'] = '14px'
          data.options5['subtitle']['text']="świadczenia na rzecz pracowników " +( opkNumber.hasOwnProperty("value") && opkNumber.value!== "" ?("nr OPK "+opkNumber.value ):"" ) +( startData?(" od "+( new Date(startData).getMonth()+1)+"/"+new Date(startData).getFullYear()) : "") +( endData?(" do "+( new Date(endData).getMonth()+1)+"/"+new Date(endData).getFullYear()) : "")
          data.options5['colors']=['#ff6d32']
          data.options5['dataLabels']={
            enabled: true,
            formatter: function (val) {
              return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") + " zł";
            },
            offsetY: -20,
            style: dataLabelStyle
          }
          data.options5['yaxis']['labels'] = {
            show: true,
            formatter: function (val) {
              return (Number(val).toFixed()).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") ;
            }}
          data.options5['tooltip']['y'] = {
            show: true,
            formatter: function(val){return val.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") + " zł"},
          }

          data.options6['title']['text']="Zestawienie wartościowe kosztów rodzajowych - konto syntetyczne 406 Pozostałe koszty rodzajowe " 
          data.options6['colors']=['#88d14c']
          data.options6['yaxis']['labels'] = {
            show: true,
            formatter: function (val) {
              return (Number(val).toFixed()).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") ;
            }}
          data.options6['dataLabels']={
            enabled: true,
            formatter: function (val) {
              return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") + " zł";
            },
            offsetY: -20,
            style: dataLabelStyle
          }
          data.options6['tooltip']['y'] = {
            show: true,
            formatter: function(val){return val.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") + " zł"},
          }


          // values = {}
          // series.forEach(val => {
          //   values[val] = []
          // })

        ///stary wykres
          // data.options= {
          //   chart: {
          //     type: 'bar',
          //     height: 590,
          //     stacked: true,
          //     stackType: '100%'
          //   },
          //   plotOptions: { bar: { horizontal: true } },
          //   dataLabels: {
          //     formatter: function (val, opt) {
          //       return val?val.toFixed(1)+'%':''
          //     }
          //   },
          //   xaxis:{categories:[], labels:{minWidth:750, style:{fontSize:10}}},
          //   legend: {
          //     position: 'top',
          //     horizontalAlign: 'center',
          //     offsetX: 40
          //   },
          //   tooltip:{
          //     followCursor: true,
          //     shared: false,
          //     custom: function({seriesIndex, dataPointIndex}) {
          //       let opk = Object.keys(dataChart)[dataPointIndex]
          //       let val = dataChart[opk].values[seriesIndex+1]
          //       let val_p = val/dataChart[opk].suma*100
          //       let tooltip = '<div class="arrow-box" style="padding: 5px; ">'
          //       tooltip+='<div style="padding: 3px; text-decoration: underline; font-weight: bold; ">'+opk+'</div>'
          //       tooltip+='<div>'
          //       tooltip+='Wartość: '+val.toFixed(2)+' zł<br>'
          //       tooltip+='Udział w koszcie całkowitym OPK: '+val_p.toFixed(2)+' %'
          //       tooltip+= '</div></div>'
          //       return tooltip
          //     }
          //   }
          // }
          // if(Object.keys(dataChart).length>8) data.options.chart.height = 500 + (Object.keys(dataChart).length-8)*30

          // series = Object.keys(dataChart[Object.keys(dataChart)[0]].values)
          // colNamesDict = {
          //   "1": "Styczeń", "2": "Luty", "3": "Marzec", "4": "Kwiecień", "5": "Maj", "6": "Czerwiec", 
          //   "7": "Lipiec", "8": "Sierpień", "9": "Wrzesień", "10": "Październik", "11": "Listopad", "12": "Grudzień"
          // }
          // values = {}
          // series.forEach(val => {
          //   values[val] = []
          // })
          // Object.entries(dataChart).map(([opk, item], i)=>{
          //   series.forEach(val => {
          //     values[val].push(Number(item.values[val]))
          //   })
          // })
          // series.forEach(val=>{
          //   data.series.push({
          //     name: colNamesDict[val],
          //     data: values[val]
          //   })
          // })
          // categories=[]
          // Object.keys(dataChart).forEach(elem=>{
          //   categories.push(elem+" "+ dataChart[elem].name)
          // })

          // data.options.xaxis.categories = categories.map(cur => {
          //   const splitedItems = cur.trim().split(" ");
          //   const arrayOfSingleString = [];
          //   let str = "";
          //   while (splitedItems.length > 0) {
          //     const item = splitedItems.shift();
          //     if (str.length + item.length >= 13) {
          //       // trying to make a chunk
          //       arrayOfSingleString.push(str);
          //       // clearing the str because it has been pushed to arrayOfSingleString
          //       str = item;
          //     } else {
          //       // concat the str with curent word
          //       str = str ? `${str} ${item}` : item;
          //     }
          //   }
          //   arrayOfSingleString.push(str);
          //   return arrayOfSingleString;
          // })
          // data.options.xaxis.categories=categories

          // data.options.xaxis.categories = Object.keys(dataChart)
          // data.options.xaxis.categories.forEach(elem=>{
          //   elem = elem + dataChart[elem]['name']
          // })
          // data.options = {
          //   chart: {
          //     type: 'line',
          //     height: 500,
          //   },
          //   dataLabels: {
          //     enabled: false,
          //     formatter: function (val, opt) {
          //       return val?val.toFixed()+'%':''
          //     }
          //   },
          //   stroke: {
          //     curve: 'smooth'
          //   },
          //   xaxis:{
          //     type: 'category',
          //     tickPlacement: 'between',
          //     categories: [],
          //   },
          //   yaxis:{
          //     labels:{
          //       formatter:(val)=>{return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')}
          //     }
          //   }
          // }
          
          // series = Object.keys(dataChart[Object.keys(dataChart)[0]].values)
          // colNamesDict = {
          //     "1": "Styczeń", "2": "Luty", "3": "Marzec", "4": "Kwiecień", "5": "Maj", "6": "Czerwiec", 
          //     "7": "Lipiec", "8": "Sierpień", "9": "Wrzesień", "10": "Październik", "11": "Listopad", "12": "Grudzień"
          //   }
          // series.forEach(month => data.options.xaxis.categories.push(colNamesDict[month]))
          // values = {}
          // Object.keys(dataChart).forEach(val => {
          //   values[val] = []
          // })
          // Object.entries(dataChart).map(([opk, item], i)=>{
          //   series.forEach(val => {
          //     values[opk].push(Number(item.values[val].toFixed(2)))
          //   })
          // })
          // data.series=[]
          // Object.keys(dataChart).forEach(opk=>{
          //   data.series.push({
          //     name: opk,
          //     data: values[opk]
          //   })
          // })
          break;
        case 3.2: 
        data.series= [{
          name: 'Koszty rodzajowe',
          type: 'column',
          data: []
        }, {
          name: 'Dynamika',
          type: 'line',
          data: []
        }]
        data.series1= [{
          name: 'Koszty rodzajowe',
          type: 'column',
          data: []
        }, {
          name: 'Dynamika',
          type: 'line',
          data: []
        }]
        data.series2= [{
          name: 'Koszty rodzajowe',
          type: 'column',
          data: []
        }, {
          name: 'Dynamika',
          type: 'line',
          data: []
        }]
        data.series3= [{
          name: 'Koszty rodzajowe',
          type: 'column',
          data: []
        }, {
          name: 'Dynamika',
          type: 'line',
          data: []
        }]
        data.series4= [{
          name: 'Koszty rodzajowe',
          type: 'column',
          data: []
        }, {
          name: 'Dynamika',
          type: 'line',
          data: []
        }]
        data.series5= [{
          name: 'Koszty rodzajowe',
          type: 'column',
          data: []
        }, {
          name: 'Dynamika',
          type: 'line',
          data: []
        }]
        data.series6= [{
          name: 'Koszty rodzajowe',
          type: 'column',
          data: []
        }, {
          name: 'Dynamika',
          type: 'line',
          data: []
        }]
        data.options= {
          chart: {
            height: 350,
            type: 'line',
            zoom: { enbaled: false }
          },
          stroke: {
            width: [0, 4]
          },
          title: {
            text: 'Dynamika kosztów kosztów rodzajowych - konto syntetyczne 400 Amortyzacja',
            align: 'center',
            style: titleStyle
          },
          subtitle: {
            text: ( opkNumber.hasOwnProperty("value") && opkNumber.value!== "" ?("nr OPK "+opkNumber.value ):"" ) +( startData?(" od "+( new Date(startData).getMonth()+1)+"/"+new Date(startData).getFullYear()) : "") +( endData?(" do "+( new Date(endData).getMonth()+1)+"/"+new Date(endData).getFullYear()) : ""),
            align: 'center',
            style: titleStyle
          },
          plotOptions: {
            bar: {
              // horizontal:true,
              columnWidth: '50%',
              borderRadius: 10,
              dataLabels: {
                position: 'top',
            // top, center, bottom
          },
            }
          },
          dataLabels: {
            enabled: true,
            // textAnchor: 'end',
            enabledOnSeries: undefined,
            style: {...dataLabelStyle, colors:['black','#ebbf34']},
            formatter: function (val, opts) {
              if(opts.seriesIndex===0) return val.toString().replace('.',',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') +' zł'
              return val.toString().replace('.',',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') + ' %'
            },
            background: {
              enabled: false,
              // foreColor:['white','white']
            },
            offsetY:-10,
          },
          labels: ['01 Jan 2001', '02 Jan 2001', '03 Jan 2001', '04 Jan 2001', '05 Jan 2001', '06 Jan 2001', '07 Jan 2001', '08 Jan 2001', '09 Jan 2001', '10 Jan 2001', '11 Jan 2001', '12 Jan 2001'],
          xaxis: {
            // type: 'datetime'
          },
          yaxis: [{
            title: {
              text: 'Koszty rodzajowe [zł]',
            },
            labels:{
              show: true,
              formatter: function (val) {
              return (Number(val).toFixed(0)).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") ;
              }}
          
          }, {
            opposite: true,
            title: {
              text: 'Dynamika [%]'
            },
            labels:{
              show: true,
              formatter: function (val) {
              return (Number(val).toFixed(2)).toString().replace(".",",") + '%' ;
              }}
          }],
          colors:['#00c0d1','#ebb814'],
          legend:{show:true, markers:{radius:2}},
          tooltip: { enabled: false}
       };
       colNamesDict = {
        "1": "Styczeń", "2": "Luty", "3": "Marzec", "4": "Kwiecień", "5": "Maj", "6": "Czerwiec", 
        "7": "Lipiec", "8": "Sierpień", "9": "Wrzesień", "10": "Paź", "11": "Listopad", "12": "Grudzień"
      }
        series=[[],[0]]
        series1 = [[],[0]]
        series2 = [[],[0]]
        series3 = [[],[0]]
        series4 = [[],[0]]
        series5 = [[],[0]]
        series6 = [[],[0]]
        categories = []
       Object.entries(dataChart['400']['values']).map(([key,value],i)=>{
        if(!dataChart['400']['values'][key]){
          // series[0].push(0); series[1].push(0);series1[0].push(0); series1[1].push(0);  
        }
        else{
          if(Object.keys(dataChart).includes('400')) series[0].push(Number(dataChart['400']['values'][key].toFixed(2)))
          if(Object.keys(dataChart).includes('401')) series1[0].push(Number(dataChart['401']['values'][key].toFixed(2)))
          if(Object.keys(dataChart).includes('402')) series2[0].push(Number(dataChart['402']['values'][key].toFixed(2)))
          if(Object.keys(dataChart).includes('403')) series3[0].push(Number(dataChart['403']['values'][key].toFixed(2)))
          if(Object.keys(dataChart).includes('404')) series4[0].push(Number(dataChart['404']['values'][key].toFixed(2)))
          if(Object.keys(dataChart).includes('405')) series5[0].push(Number(dataChart['405']['values'][key].toFixed(2)))
          if(Object.keys(dataChart).includes('406')) series6[0].push(Number(dataChart['406']['values'][key].toFixed(2)))
          if(i !== 0){
            if(Object.keys(dataChart).includes('400')) series[1].push(Number(dataChart['400']['values_dyn'][key].toFixed(2)))
            if(Object.keys(dataChart).includes('401')) series1[1].push(Number(dataChart['401']['values_dyn'][key].toFixed(2)))
            if(Object.keys(dataChart).includes('402')) series2[1].push(Number(dataChart['402']['values_dyn'][key].toFixed(2)))
            if(Object.keys(dataChart).includes('403')) series3[1].push(Number(dataChart['403']['values_dyn'][key].toFixed(2)))
            if(Object.keys(dataChart).includes('404')) series4[1].push(Number(dataChart['404']['values_dyn'][key].toFixed(2)))
            if(Object.keys(dataChart).includes('405')) series5[1].push(Number(dataChart['405']['values_dyn'][key].toFixed(2)))
            if(Object.keys(dataChart).includes('406')) series6[1].push(Number(dataChart['406']['values_dyn'][key].toFixed(2)))
          }
       categories.push(colNamesDict[key])
        }
        
      })
      data.options.labels = categories


      data.series[0].data = series[0]
      data.series[1].data = series[1]

      data.series1[0].data = series1[0]
      data.series1[1].data = series1[1]

      data.series2[0].data = series2[0]
      data.series2[1].data = series2[1]

      data.series3[0].data = series3[0]
      data.series3[1].data = series3[1]

      data.series4[0].data = series4[0]
      data.series4[1].data = series4[1]

      data.series5[0].data = series5[0]
      data.series5[1].data = series5[1]

      data.series6[0].data = series6[0]
      data.series6[1].data = series6[1]

      data.options1 = JSON.parse(JSON.stringify(data.options))
      data.options1['title']['text']="Dynamika kosztów kosztów rodzajowych - konto syntetyczne 401 Zużycie materiałów i energii"
      data.options1['colors']=['#eb6b6b','#ebb814']
      data.options1['yaxis'][0]['labels'] = {
        show: true,
        formatter: function (val) {
          return (Number(val).toFixed()).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") ;
        }}
      data.options1['yaxis'][1]['labels'] = {
        show: true,
        formatter: function (val) {
          return (Number(val).toFixed(2)).toString().replace(".",",") + '%'  ;
        }}
      data.options1['dataLabels'] = {
        enabled: true,
        offsetY:-8,
        enabledOnSeries: undefined,
        style: {...dataLabelStyle, colors:['black','#ebbf34']},
        formatter: function (val, opts) {
          if(opts.seriesIndex===0) return val.toString().replace('.',',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') +' zł'
          return val.toString().replace('.',',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') + ' %'
      },
      background: {
        enabled: false,
       },
      }

      data.options2 = JSON.parse(JSON.stringify(data.options))
      data.options2['title']['text']="Dynamika kosztów kosztów rodzajowych - konto syntetyczne 402 Usługi obce"
      data.options2['colors']=['#006ba7','#ebb814']
      data.options2['yaxis'][0]['labels'] = {
        show: true,
        formatter: function (val) {
          return (Number(val).toFixed()).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") ;
        }}
      data.options2['yaxis'][1]['labels'] = {
        show: true,
        formatter: function (val) {
          return (Number(val).toFixed(2)).toString().replace(".",",") + '%'  ;
        }}
      data.options2['dataLabels'] = {
        enabled: true,
        // textAnchor: 'end',
        offsetY:-8,
        enabledOnSeries: undefined,
        style: {...dataLabelStyle, colors:['black','#ebbf34']},
        formatter: function (val, opts) {
          if(opts.seriesIndex===0) return val.toString().replace('.',',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') +' zł'
          return val.toString().replace('.',',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') + " %"
        },
        background: {
          enabled: false,
        },
      }

      data.options3 = JSON.parse(JSON.stringify(data.options))
      data.options3['title']['text']="Dynamika kosztów kosztów rodzajowych - konto syntetyczne 403 Podatki i opłaty" 
      data.options3['colors']=['#00b881','#ebb814']
      data.options3['yaxis'][0]['labels'] = {
        show: true,
        formatter: function (val) {
          return (Number(val).toFixed()).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") ;
        }}
      data.options3['yaxis'][1]['labels'] = {
        show: true,
        formatter: function (val) {
          return (Number(val).toFixed(2)).toString().replace(".",",") + '%'  ;
        }}
      data.options3['dataLabels'] = {
        enabled: true,
        offsetY:-8,
        // textAnchor: 'end',
        style: {...dataLabelStyle, colors:['black','#ebbf34']},
        enabledOnSeries: undefined,
        formatter: function (val, opts) {
          if(opts.seriesIndex===0) return val.toString().replace('.',',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') +' zł'
          return val.toString().replace('.',',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') + ' %'
        },
        background: {
          enabled: false,
        },
      }

      data.options4 = JSON.parse(JSON.stringify(data.options))
      data.options4['title']['text']="Dynamika kosztów kosztów rodzajowych - konto syntetyczne 404 Wynagrodzenia" 
      data.options4['colors']=['#a3a3e0','#ebb814']
      data.options4['yaxis'][0]['labels'] = {
        show: true,
        formatter: function (val) {
          return (Number(val).toFixed()).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") ;
        }}
      data.options4['yaxis'][1]['labels'] = {
        show: true,
        formatter: function (val) {
          return (Number(val).toFixed(2)).toString().replace(".",",") + '%'  ;
        }}
        data.options4['dataLabels'] = {
          enabled: true,
          offsetY:-8,
          // textAnchor: 'end',
          style: {...dataLabelStyle, colors:['black','#ebbf34']},
          enabledOnSeries: undefined,
          formatter: function (val, opts) {
            if(opts.seriesIndex===0) return val.toString().replace('.',',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') +' zł'
            return val.toString().replace('.',',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') + ' %'
          },
          background: {
            enabled: false,
          },
        }
      
      data.options5 = JSON.parse(JSON.stringify(data.options))
      data.options5['title']['text']="Dynamika kosztów kosztów rodzajowych - konto syntetyczne 405 Składki na rzecz (ZUS) i inne "
      data.options5['subtitle']['text']="świadczenia na rzecz pracowników" +"  "+( opkNumber.hasOwnProperty("value") && opkNumber.value!== "" ?("nr OPK "+opkNumber.value ):"" ) +( startData?(" od "+( new Date(startData).getMonth()+1)+"/"+new Date(startData).getFullYear()) : "") +( endData?(" do "+( new Date(endData).getMonth()+1)+"/"+new Date(endData).getFullYear()) : "")
      data.options5['title']['style']['fontSize']='14px'
      data.options5['colors']=['#ff6d32','#ebb814']
      data.options5['yaxis'][0]['labels'] = {
        show: true,
        formatter: function (val) {
          return (Number(val).toFixed()).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") ;
        }}
      data.options5['yaxis'][1]['labels'] = {
        show: true,
        formatter: function (val) {
          return (Number(val).toFixed(2)).toString().replace(".",",") + '%'  ;
        }}
      data.options5['dataLabels'] = {
        enabled: true,
        offsetY:-8,
        // textAnchor: 'end',
        style: {...dataLabelStyle, colors:['black','#ebbf34']},
        enabledOnSeries: undefined,
        formatter: function (val, opts) {
          if(opts.seriesIndex===0) return val.toString().replace('.',',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') +' zł'
          return val.toString().replace('.',',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') + ' %'
        },
        background: {
          enabled: false,
        },
      }

      data.options6 = JSON.parse(JSON.stringify(data.options))
      data.options6['title']['text']="Dynamika kosztów kosztów rodzajowych - konto syntetyczne 406 Pozostałe koszty rodzajowe" 
      data.options6['colors']=['#88d14c','#ebb814']
      data.options6['yaxis'][0]['labels'] = {
        show: true,
        formatter: function (val) {
          return (Number(val).toFixed()).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") ;
        }}
      data.options6['yaxis'][1]['labels'] = {
        show: true,
        formatter: function (val) {
          return (Number(val).toFixed(2)).toString().replace(".",",") + '%'  ;
        }}
      data.options6['dataLabels'] = {
        enabled: true,
        offsetY:-8,
        // textAnchor: 'center',
        style: {...dataLabelStyle, colors:['black','#ebbf34']},
        enabledOnSeries: undefined,
        formatter: function (val, opts) {
          if(opts.seriesIndex===0) return val.toString().replace('.',',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') +' zł'
          return val.toString().replace('.',',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') + ' %'
        },
        background: {
          enabled: false,
        },
      }

        //tutaj liniowy pod spodem
          // data.options = {
          //   chart: {
          //     type: 'line',
          //     height: 500,
          //   },
          //   dataLabels: {
          //     enabled: false,
          //     formatter: function (val, opt) {
          //       return val?val.toFixed()+'%':''
          //     }
          //   },
          //   stroke: {
          //     curve: 'smooth'
          //   },
          //   xaxis:{
          //     type: 'category',
          //     tickPlacement: 'between',
          //     categories: [],
          //   }
          // }
          
          // series = Object.keys(dataChart[Object.keys(dataChart)[0]].values_dyn)
          // colNamesDict = {
          //   "2": "luty/styczeń", 
          //   "3": "marzec/luty", 
          //   "4": "kwiecień/marzec", 
          //   "5": "maj/kwiecień", 
          //   "6": "czerwiec/maj", 
          //   "7": "lipiec/czerwiec", 
          //   "8": "sierpień/lipiec", 
          //   "9": "wrzesień/sierpień", 
          //   "10": "październik/wrzesień", 
          //   "11": "listopad/październik", 
          //   "12": "grudzień/styczeń", 
          // }
          // series.forEach(month => data.options.xaxis.categories.push('Dynamika '+colNamesDict[month]))
          // values = {}
          // Object.keys(dataChart).forEach(val => {
          //   values[val] = []
          // })
          // Object.entries(dataChart).map(([opk, item], i)=>{
          //   series.forEach(val => {
          //     values[opk].push(Number(item.values_dyn[val].toFixed(2)))
          //   })
          // })
          // data.series=[]
          // Object.keys(dataChart).forEach(opk=>{
          //   data.series.push({
          //     name: opk,
          //     data: values[opk]
          //   })
          // })
          
          break;
        case 4:
          // if(dataChart=== "No number selected"){return <div>Wybierz numer OPK</div>}
          data.options= {
            chart: {
              type: 'bar',
              height: 800,
              stacked: true,
              stackType: '100%'
            },
            // columnWidth: '50%',
            plotOptions: { bar: { horizontal: false,columnWidth: '50%',dataLabels: {hideOverflowingLabels: false} } },
            dataLabels: {
              enabled:true,
              style: {...dataLabelStyle, colors: ['white']},
              formatter: function (val, opt) {
                if(val<5 && val!==0) {
                  return valueConvert(val)+'%'}
                return val?valueConvert(val)+'%':''
              }
            },
            xaxis:{
              categories:[],
              labels: {
                style:{
                  fontWeight: 600
                }
              }
            },
            legend: {
              position: 'bottom',
              horizontalAlign: 'center',
              offsetX: 40
            },
             yaxis: {
              tickAmount: 20,
              // tickAmount: 100,

              labels: {
                formatter: function(val) {
                  // if(val<20) return '5%'
                  return parseFloat(val).toFixed()+'%'
                },
                show: true,
                minWidth: 0,
              },
              // title: { text: 'Koszt wykonanych procedur [zł]' }
            },
            tooltip:{
              followCursor: true,
              shared: false,
              custom: function({seriesIndex}) {
                let koszty ={
                  'koszty bezpośrednie':'dir_cost', 
                  'koszty działalności pomocniczej medycznej': 'koszt_dzial_medycz',
                  'koszty działalności pomocniczej niemedycznej': 'koszt_dzial_niemedycz', 
                  'koszty procedur medycznych': 'procedural_cost', 
                  'koszty zarządu': 'manag_cost',
                  "koszty stałe": 'koszty_stale_opk',
                  "koszty zmienne": 'koszty_zmienne_opk'
                }
                let title = Object.keys(koszty)[seriesIndex]
                let val = dataChart[koszty[title]]
                let val_p =  dataChart[koszty[title]+'_p']
                if(title==='koszty stałe'||title==='koszty zmienne') val_p=val/(dataChart['koszty_stale_opk']+dataChart['koszty_zmienne_opk'])*100

                let tooltip = '<div class="arrow-box" style="padding: 5px; font-size:10px;">'
                tooltip+='<div style="padding: 3px; font-weight: bold;">'+title+'</div>'
                tooltip+='<div>'
                tooltip+='Wartość: '+valueConvert(val)+' zł<br>'
                tooltip+='Udział w koszcie całkowitym OPK: '+valueConvert(val_p)+' %'
                tooltip+= '</div></div>'
                return tooltip
              }
            },
            colors:['#3889a2','#1e72b2','#ffb061','#8f98cd','#ffe07d', '#59ade1','#eb6b6b'],
            title: {
              text: "Koszt całkowity ośrodka powstawania kosztów - analityka", 
              align: 'center',
              margin: 10,
              offsetX: 0,
              floating: false,
              style: titleStyle,
          },
          subtitle: {
            text: ( opkNumber.hasOwnProperty("value") && opkNumber.value!== "" ?("nr OPK "+opkNumber.value ):"" ) +( startData?(" od "+( new Date(startData).getMonth()+1)+"/"+new Date(startData).getFullYear()) : "") +( endData?(" do "+( new Date(endData).getMonth()+1)+"/"+new Date(endData).getFullYear()) : ""), 
            align: 'center',
            margin: 10,
            offsetY: 20,
            floating: false,
            style: titleStyle,
        }
          }
          data.series = [{name:"koszty bezpośrednie",data:[dataChart['dir_cost'],0]},{name:"koszty działalności pomocniczej medycznej",data:[dataChart['koszt_dzial_medycz']]},
          {name:"koszty działalności pomocniczej niemedycznej",data:[dataChart['koszt_dzial_niemedycz'],0]},{name:"koszty procedur medycznych",data:[dataChart['procedural_cost'],0]},
          {name:"koszty zarządu",data:[dataChart['manag_cost'],0]},
          {name:"koszty stałe",data:[0,dataChart['koszty_stale_opk']]},{name:"koszty zmienne",data:[0,dataChart['koszty_zmienne_opk']]}]
          
          data.options.xaxis.categories = ["Koszty wg miejsc powstawania","Koszty wg stopnia zależności od liczby udzielonych świadczeń"]
          // data.options.colors=['#3889a2','#1e72b2','#ffb061','#8f98cd','#ffe07d']

          break;
        case 5:
          //  PIECHART
            data.series=[]
            data.options = {
              chart: {
                height: 500,
                type: 'pie',
              },
              colors: ['#00c0d1', '#eb6b6b', '#004a74', '#00b882', '#a3a3e0', '#fe8622', '#88d14c'].concat(colorPalette),
              labels: [],
              plotOptions:{
                pie:{  dataLabels:{
                  // offset: 0,
                  minAngleToShowLabel: 1, size: '80%'}}

              },
              dataLabels: {
                enabled:true,
                style: {...dataLabelStyle, colors: ['white']},
                formatter: function (val, opt) {
                  return valueConvert(val)+'%'

                  // return val?val.toFixed(1)+'%':''
                }
              },
              // plotOptions: { bar: { horizontal: false,columnWidth: '50%',dataLabels: {hideOverflowingLabels: false} } },
              responsive: [{
                breakpoint: 600,
                options: {
                  chart: {
                    width: 450
                  },
                  legend: {
                    position: 'top',
                    width: 200
                  }
                }
              }],
              legend: {
                position: 'bottom',
                width: active===6?350:undefined,
                formatter: function (val) {
                  // return val.split(' (')[0]
                  return val +" - "+ dataChart[val].name
                },
                markers:{radius:2}
              },
              tooltip:{
                custom: function({series, seriesIndex}) {
                  let opkSansZero = Object.keys(dataChart).filter(item => {return dataChart[item]['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]']!==0})
                  let opk = opkSansZero[seriesIndex]
                  let tooltip = '<div class="arrow-box chart-tooltip text-left" >'
                  tooltip+='<div style="padding: 3px; font-weight: bold; ">'+opk+" - "+ dataChart[opk].name+'</div>'
                  tooltip+='<div>'
                  tooltip+='Wartość kosztu: '+valueConvert(dataChart[opk]["WARTOŚĆ KOSZTU [ZŁ]"])+' zł<br>'
                  tooltip+='Udział w kosztach bezpośrednich OPK: '+valueConvert(dataChart[opk]["UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]"])+' %'
                  tooltip+= '</div></div>'
                  return tooltip
                }
              },
              title: {
                text: "Koszty bezpośrednie ośrodka powstawania kosztów (analityka kont zespołu 4)" ,
                align: 'center',
                margin: 10,
                offsetX: 0,
                offsetY: 0,
                floating: false,
                style: titleStyle,
            },
            subtitle: {
              text: ( opkNumber.hasOwnProperty("value") && opkNumber.value!== "" ?("nr OPK "+opkNumber.value ):"" ) +( startData?(" od "+( new Date(startData).getMonth()+1)+"/"+new Date(startData).getFullYear()) : "") +( endData?(" do "+( new Date(endData).getMonth()+1)+"/"+new Date(endData).getFullYear()) : ""), 
              align: 'center',
              margin: 10,
              offsetY: 20,
              floating: false,
              style: titleStyle,
          }
            }
            Object.entries(dataChart).map(([opk, item], i)=>{
              if(opk!=="Suma"&&item['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]']!==0){
                data.series.push(Number(item['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]']))
                data.options.labels.push(opk)
              }
            })
          // BAR
          // data.series = [{
          //   data: []
          // }]
          // data.options = {
          //   chart: {
          //     type: 'bar',
          //     height: 500
          //   },
          //   colors: ['#5cb8fa'],
          //   plotOptions: {
          //     bar: {
          //       borderRadius: 4,
          //       horizontal: true,
          //       dataLabels: {
          //         hideOverflowingLabels: false,
          //         position: 'top',
          //       }
          //     }
          //   },
          //   dataLabels: {
          //     enabled: true,
          //     formatter: function (val, opts) {
          //       return valueConvert(val) + "%";
          //     },
          //     offsetX: 50,
          //     offsetY: 0,
          //     style: { ...dataLabelStyle },
          //   },
          //   xaxis: {
          //     categories: [],
          //     labels: {
          //       show: true,
          //       minHeight: -250,
          //       rotate: -80,
          //       minWidth: 250,
          //       style: {
          //         fontSize: '10px',
          //         fontFamily: 'Helvetica, Arial, sans-serif',
          //         fontWeight: 200,
          //         cssClass: 'apexcharts-xaxis-label',
          //       },
          //     }
          //   },
          //   yaxis: {
          //   },
          //   tooltip: {
          //     followCursor: true,
          //     shared: false,
          //     custom: function ({ series, seriesIndex, dataPointIndex }) {
          //       let opkSansZero = Object.keys(dataChart).filter(item => { return dataChart[item]['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]'] !== 0 })
          //       let opk = opkSansZero[seriesIndex]
          //       let tooltip = '<div class="arrow-box chart-tooltip text-left" >'
          //       tooltip += '<div style="padding: 3px; font-weight: bold; ">' + opk + " - " + dataChart[opk].name + '</div>'
          //       tooltip += '<div>'
          //       tooltip += 'Wartość kosztu: ' + valueConvert(dataChart[opk]["WARTOŚĆ KOSZTU [ZŁ]"]) + ' zł<br>'
          //       tooltip += 'Udział w kosztach bezpośrednich OPK: ' + valueConvert(dataChart[opk]["UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]"]) + ' %'
          //       tooltip += '</div></div>'
          //       return tooltip
          //     }
          //   },
          //   title: {
          //     text: "Koszty bezpośrednie ośrodka powstawania kosztów (analityka kont zespołu 4)",
          //     align: 'center',
          //     margin: 10,
          //     offsetX: 0,
          //     offsetY: 0,
          //     floating: false,
          //     style: titleStyle,
          //   },
          //   subtitle: {
          //     text: (opkNumber.hasOwnProperty("value") && opkNumber.value !== "" ? ("nr OPK " + opkNumber.value) : "") + (startData ? (" od " + (new Date(startData).getMonth() + 1) + "/" + new Date(startData).getFullYear()) : "") + (endData ? (" do " + (new Date(endData).getMonth() + 1) + "/" + new Date(endData).getFullYear()) : ""),
          //     align: 'center',
          //     margin: 10,
          //     offsetY: 20,
          //     floating: false,
          //     style: titleStyle,
          //   }
          // }
          // //vertkalnie
          // data.series = [{
          //   data: []
          // }]
          // categories = []

          // Object.entries(dataChart).map(([opk, item], i) => {
          //   if (opk !== "Suma" && item['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]'] !== 0) {
          //     data.series[0].data.push(Number(item['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]']))
          //     categories.push(opk)
          //   }
          // })

          // data.options.xaxis.categories = categories
          // data.options.xaxis.categories = categories.map(cur => {
          //   var iterator = 0
          //   const splitedItems = cur.trim().split(" ");
          //   const arrayOfSingleString = [];
          //   let str = "";
          //   while (splitedItems.length > 0) {
          //     const item = splitedItems.shift();
          //     if (str.length + item.length >= 20) {
          //       arrayOfSingleString.push(str);
          //       str = item;
          //     } else {
          //       str = str ? `${str} ${item}` : item;
          //     }
          //   }
          //   arrayOfSingleString.push(str);
          //   return arrayOfSingleString;
          // })
          // data.options.yaxis.max = Math.max(...data.series[0].data)

          // if (dataChart.length > 9) data.options.chart.height = 500 + (dataChart.length - 9) * 30

          break;
        case 6:  
        case 7:
        //horyzontalnie 
          data.series= [{
              data: []
            }]
            data.options= {
              chart: {
                type: 'bar',
                height: 500
              },
              colors:['rgb(0,192,209)'],
              plotOptions: {
                bar: {
                  borderRadius: 4,
                  horizontal: true,
                  dataLabels:{
                    hideOverflowingLabels: false,
                    position: 'top',
                  }
                }
              },
              dataLabels: {
                enabled: true,
                formatter: function (val,  opts) {
                          return valueConvert(val) + "%"  ;
                        },
                offsetX: 50,
                offsetY: 0,
                style: {...dataLabelStyle},
              },
              xaxis: {
                categories: [ ],
                labels:{
                  show:true,
                  minHeight: -250,
                  rotate: -80,
                  minWidth:250,
                  style: {
                    fontSize: '10px',
                    fontFamily: 'Helvetica, Arial, sans-serif',
                    fontWeight: 200,
                    cssClass: 'apexcharts-xaxis-label',
                  },
                  
                }
              },
              yaxis:{
                forceNiceScale: true
              },
              tooltip:{
                  followCursor: true,
                  shared: false,
                  custom: function({series, seriesIndex, dataPointIndex}) {
                    let key = categories[dataPointIndex]
                    let val_pr = series[0][dataPointIndex]
                    console.log(series)
                    let val
                    if(active==6) val = dataChart['Wartość ogółem']["WARTOŚĆ KOSZTU [ZŁ]"]*val_pr/100
                    else val = dataChart.find(element => element.code == key)
                    let tooltip = '<div class="arrow-box" style="padding: 5px; font-size:10px;">'
                    tooltip+='<div style="padding: 3px; font-weight: bold; ">'+key.split('(')[0]+'</div>'
                    tooltip+='<div>'
                    if(active==6) {
                      tooltip+='Wartość kosztu: '+valueConvert(val)+' zł<br>'
                      tooltip+='Udział w koszcie całkowitym OPK: '+valueConvert(val_pr)+' %'
                    }else{ //7
                      let type = opkNumber.value.split('-')[0]=='507'?'procedur':'usług'
                      tooltip+=`Liczba wykonanych ${type}: ${valueConvert(val.liczba_proc_us, 0)}`+'<br>'
                      tooltip+=`Koszt wykonanych ${type}: ${valueConvert(val.koszt_proc_us)}`+' zł<br>'
                      tooltip+='Przekazany koszt: '+valueConvert(val.przek_koszt)+' %'
                    }
                    tooltip+= '</div></div>'
                    return tooltip
                  }
                },
                title: {
                  text: "Koszty bezpośrednie ośrodków powstawania kosztów (grupy kosztów kont zespołu 4)" ,
                  align: 'center',
                  margin: 10,
                  offsetX: 0,
                  offsetY: 0,
                  floating: false,
                  style: titleStyle,
              },
              subtitle: {
                text: ( opkNumber.hasOwnProperty("value") && opkNumber.value!== "" ?("nr OPK "+opkNumber.value ):"" ) +( startData?(" od "+( new Date(startData).getMonth()+1)+"/"+new Date(startData).getFullYear()) : "") +( endData?(" do "+( new Date(endData).getMonth()+1)+"/"+new Date(endData).getFullYear()) : ""), 
                align: 'center',
                margin: 10,
                offsetY: 20,
                floating: false,
                style: titleStyle,
            }
            }
 

          //vertkalnie
          data.series= [{
            data: []
          }]
          categories = []
          // ForTolltip = []
          var inne = 0

          if(active === 7) {
            data.options.title.text = 'Koszty przeniesione na ośrodki powstawania kosztów poprzez zlecone usługi/procedury'  
            data.options.subtitle.text = '- według ośrodka wykonującego '+( opkNumber.hasOwnProperty("value") && opkNumber.value!== "" ?("nr OPK "+opkNumber.value ):"" ) +( startData?(" od "+( new Date(startData).getMonth()+1)+"/"+new Date(startData).getFullYear()) : "") +( endData?(" do "+( new Date(endData).getMonth()+1)+"/"+new Date(endData).getFullYear()) : "")
            dataChart.forEach(item =>{
              if(item.przek_koszt!==0&&item.code!=='Wartość ogółem'){
                data.series[0].data.push(item.przek_koszt)
                categories.push(item.code)
              }
            })
          }else{ //6
            Object.entries(dataChart).map(([opk, item], i)=>{
              if(opk!=="Wartość ogółem"&&item['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]']!==0){
                if(Number(item['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]'])>1){
                data.series[0].data.push(Number(item['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]']))
                // ForTolltip.push(Number(item['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]']))
                categories.push(opk)}
                else {
                  inne = inne + Number(item['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]']) 
                }
              }
            })
            data.series[0].data.push(Number(inne.toFixed(2)))
            categories.push("inne < 1%")
          }
          categories.forEach((category,i) => { categories[i] = (category.split('(')[0]);})
          data.options.xaxis.categories=categories
          data.options.xaxis.categories = categories.map(cur => {
            var iterator = 0
            const splitedItems = cur.trim().split(" ");
            const arrayOfSingleString = [];
            let str = "";
            while (splitedItems.length > 0) {
              // if(arrayOfSingleString.length>4){ break; return arrayOfSingleString}
              const item = splitedItems.shift();
              if (str.length + item.length >= 20) {
                // iterator = iterator + 1
                // if(iterator>4){break;}
                // trying to make a chunk
                arrayOfSingleString.push(str);
                // clearing the str because it has been pushed to arrayOfSingleString
                str = item;
              } else {
                // concat the str with curent word
                str = str ? `${str} ${item}` : item;
              }
            }
            // if(arrayOfSingleString.length>3){ return arrayOfSingleString}
            arrayOfSingleString.push(str);
            return arrayOfSingleString;
          })
          data.options.yaxis.max =Math.max(...data.series[0].data)

          if(dataChart.length>9) data.options.chart.height = 500 + (dataChart.length-9)*30

          if(data.series[0].data.length==1&&data.series[0].data[0] == 0){data.series[0].data = []}
          break;
        case 8:
          // DONUTS
          // let dataChart0 = dataChart.rep8
          // data.series = []
          // data.options = {
          //   chart: {
          //     height: 500,
          //     type: 'donut',
          //   },
          //   responsive: [{
          //     breakpoint: 480,
          //     options: {
          //       chart: {
          //         width: 200
          //       },
          //       legend: {
          //         position: 'bottom'
          //       }
          //     }
          //   }],
          //   colors: colorPalette,
          //   legend: {
          //     position: 'top',
          //     // width: active===6?350:undefined,
          //     formatter: function (val) {
          //       // return val.split(' (')[0]
          //       return val 
          //     },
          //     markers:{radius:2}
          //   },
          //   plotOptions:{
          //     pie:{   dataLabels:{
          //       // offset: 0,
          //       minAngleToShowLabel: 1}, donut:{labels:{show:false}}}

          //   },
          //   dataLabels:{
          //     style: {...dataLabelStyle, colors: ['white']},
          //     formatter:function (val, opt) {
          //       return val?valueConvert(val)+'%':""
                
          //     }
          //   },
          //   labels: [],
          //   tooltip:{
          //     custom: function({series, seriesIndex}) {
          //       let dataSansZero = dataChart0.filter(item => {return item.przek_koszt!==0})
          //       let tooltip = '<div class="arrow-box chart-tooltip text-left" >'
          //       tooltip+='<div style="padding: 3px; font-weight: bold ">'+dataSansZero[seriesIndex].code+'</div>'
          //       tooltip+='<div>'
          //       tooltip+='Liczba wykonanych procedur: '+dataSansZero[seriesIndex].liczba_proc_us+'<br>'
          //       tooltip+='Koszt wykonanych procedur: '+valueConvert(dataSansZero[seriesIndex].koszt_proc_us)+' zł<br>'
          //       tooltip+='Przekazany koszt: '+valueConvert(dataSansZero[seriesIndex].przek_koszt)+' %'
          //       tooltip+= '</div></div>'
          //       return tooltip
          //     }
          //   },
          //   title: {
          //     text: "Koszty przeniesione na  ośrodki powstawania kosztów poprzez zlecone procedury - według ośrodka zlecającego ", 
          //     align: 'center',
          //     margin: 10,
          //     offsetX: 0,
          //     offsetY: 0,
          //     floating: false,
          //     style: titleStyle,
          //   },
          //   subtitle: {
          //     text: ( opkNumber.hasOwnProperty("value") && opkNumber.value!== "" ?("nr OPK "+opkNumber.value ):"" ) +( startData?(" od "+( new Date(startData).getMonth()+1)+"/"+new Date(startData).getFullYear()) : "") +( endData?(" do "+( new Date(endData).getMonth()+1)+"/"+new Date(endData).getFullYear()) : ""), 
          //     align: 'center',
          //     margin: 10,
          //     offsetY: 20,
          //     floating: false,
          //     style: titleStyle,
          //   }
          // }

          // dataChart0.forEach(item =>{
          //   if(item.przek_koszt!==0&&item.code!=='Wartość ogółem'){
          //     data.series.push(item.przek_koszt)
          //     data.options.labels.push(item.code)
          //   }
          // })
          //   let dataChart1 = dataChart.rep82
          //   data.series1 = []
          //   data.options1 = JSON.parse(JSON.stringify(data.options))
          //   data.options1.colors = colorPalette.reverse()
          //   data.options1.legend.formatter = function (val) { return val }
          //   data.options1.dataLabels.formatter = function (val) { return val?valueConvert(val)+'%':"" }
          //   data.options1.labels = []
          //   data.options1.tooltip = {
          //     custom: function({series, seriesIndex}) {
          //       let dataSansZero = dataChart1.filter(item => {return item.przek_koszt!==0})
          //       let tooltip = '<div class="arrow-box chart-tooltip text-left">'
          //       tooltip+='<div style="padding: 3px; font-weight: bold ">'+dataSansZero[seriesIndex].code+'</div>'
          //       tooltip+='<div>'
          //       tooltip+='Liczba wykonanych usług: '+dataSansZero[seriesIndex].liczba_proc_us+'<br>'
          //       tooltip+='Koszt wykonanych usług: '+valueConvert(dataSansZero[seriesIndex].koszt_proc_us)+' zł<br>'
          //       tooltip+='Przekazany koszt: '+valueConvert(dataSansZero[seriesIndex].przek_koszt)+' %'
          //       tooltip+= '</div></div>'
          //       return tooltip
          //     }
          //   }
          //   data.options1.title.text = "Koszty przeniesione na  ośrodki powstawania kosztów poprzez zlecone usługi - według ośrodka zlecającego " 
          //   dataChart1.forEach(item =>{
          //     if(item.przek_koszt!==0&&item.code!=='Wartość ogółem'){
          //       data.series1.push(item.przek_koszt)
          //       data.options1.labels.push(item.code)
          //     }
          //   })

          // BAR
          let dataChart0 = dataChart.rep8
          data.series = [{
            data: []
          }]
            data.options = {
            chart: {
              height: 500,
              type: 'bar',
            },
            colors: ['#5cb8fa'],
            plotOptions:{
              bar: {
                borderRadius: 4,
                horizontal: true,
                dataLabels: {
                  hideOverflowingLabels: false,
                  position: 'top',
                }
              }
            },
            dataLabels:{
              enabled: true,
              style: {...dataLabelStyle},
              formatter:function (val, opt) {
                return val?valueConvert(val)+'%':""
              },
              offsetX: 50,
            },
            xaxis: {
              categories: [],
              labels: {
                show: true,
                minHeight: -250,
                rotate: -80,
                minWidth: 250,
                style: {
                  fontSize: '10px',
                  fontFamily: 'Helvetica, Arial, sans-serif',
                  fontWeight: 200,
                  cssClass: 'apexcharts-xaxis-label',
                },
              }
            },
            yaxis: {
              forceNiceScale: true
            },
            tooltip:{
              custom: function({series, seriesIndex}) {
                let dataSansZero = dataChart0.filter(item => {return item.przek_koszt!==0})
                let tooltip = '<div class="arrow-box chart-tooltip text-left" >'
                tooltip+='<div style="padding: 3px; font-weight: bold ">'+dataSansZero[seriesIndex].code+'</div>'
                tooltip+='<div>'
                tooltip+='Liczba wykonanych procedur: '+dataSansZero[seriesIndex].liczba_proc_us+'<br>'
                tooltip+='Koszt wykonanych procedur: '+valueConvert(dataSansZero[seriesIndex].koszt_proc_us)+' zł<br>'
                tooltip+='Przekazany koszt: '+valueConvert(dataSansZero[seriesIndex].przek_koszt)+' %'
                tooltip+= '</div></div>'
                return tooltip
              }
            },
            title: {
              text: "Koszty przeniesione na  ośrodki powstawania kosztów poprzez zlecone procedury - według ośrodka zlecającego ", 
              align: 'center',
              margin: 10,
              offsetX: 0,
              offsetY: 0,
              floating: false,
              style: titleStyle,
            },
            subtitle: {
              text: ( opkNumber.hasOwnProperty("value") && opkNumber.value!== "" ?("nr OPK "+opkNumber.value ):"" ) +( startData?(" od "+( new Date(startData).getMonth()+1)+"/"+new Date(startData).getFullYear()) : "") +( endData?(" do "+( new Date(endData).getMonth()+1)+"/"+new Date(endData).getFullYear()) : ""), 
              align: 'center',
              margin: 10,
              offsetY: 20,
              floating: false,
              style: titleStyle,
            }
          }
          categories = []

          dataChart0.forEach(item =>{
            if(item.przek_koszt!==0&&item.code!=='Wartość ogółem'){
              data.series[0].data.push(item.przek_koszt)
              categories.push(item.code)
            }
          })
          data.options.xaxis.categories = categories.map(cur => {
            var iterator = 0
            const splitedItems = cur.trim().split(" ");
            const arrayOfSingleString = [];
            let str = "";
            while (splitedItems.length > 0) {
              const item = splitedItems.shift();
              if (str.length + item.length >= 20) {
                arrayOfSingleString.push(str);
                str = item;
              } else {
                str = str ? `${str} ${item}` : item;
              }
            }
            arrayOfSingleString.push(str);
            return arrayOfSingleString;
          })
          data.options.yaxis.max = Math.max(...data.series[0].data)
          if (dataChart0.length > 9) data.options.chart.height = 500 + (dataChart0.length - 9) * 30


          let dataChart1 = dataChart.rep82
          data.series1 = [{
            data: []
          }]
          categories = []
          dataChart1.forEach(item =>{
            if(item.przek_koszt!==0&&item.code!=='Wartość ogółem'){
              data.series1[0].data.push(Number(item.przek_koszt))
              categories.push(item.code)
            }
          })
          data.options1 = {
            chart: {
              height: 500,
              type: 'bar',
            },
            colors: ['#ebb814'],
            plotOptions:{
              bar: {
                borderRadius: 4,
                horizontal: true,
                dataLabels: {
                  hideOverflowingLabels: false,
                  position: 'top',
                }
              }
            },
            dataLabels:{
              enabled: true,
              style: {...dataLabelStyle},
              formatter:function (val, opt) {
                return val?valueConvert(val)+'%':""
              },
              offsetX: 50,
            },
            xaxis: {
              categories: [],
              labels: {
                show: true,
                minHeight: -250,
                rotate: -80,
                minWidth: 250,
                style: {
                  fontSize: '10px',
                  fontFamily: 'Helvetica, Arial, sans-serif',
                  fontWeight: 200,
                  cssClass: 'apexcharts-xaxis-label',
                },
              }
            },
            yaxis: {
              forceNiceScale: true
            },
            tooltip:{
              custom: function({series, seriesIndex}) {
                let dataSansZero = dataChart1.filter(item => {return item.przek_koszt!==0})
                let tooltip = '<div class="arrow-box chart-tooltip text-left" >'
                tooltip+='<div style="padding: 3px; font-weight: bold ">'+dataSansZero[seriesIndex].code+'</div>'
                tooltip+='<div>'
                tooltip+='Liczba wykonanych procedur: '+dataSansZero[seriesIndex].liczba_proc_us+'<br>'
                tooltip+='Koszt wykonanych procedur: '+valueConvert(dataSansZero[seriesIndex].koszt_proc_us)+' zł<br>'
                tooltip+='Przekazany koszt: '+valueConvert(dataSansZero[seriesIndex].przek_koszt)+' %'
                tooltip+= '</div></div>'
                return tooltip
              }
            },
            title: {
              text: "Koszty przeniesione na  ośrodki powstawania kosztów poprzez zlecone usługi - według ośrodka zlecającego ", 
              align: 'center',
              margin: 10,
              offsetX: 0,
              offsetY: 0,
              floating: false,
              style: titleStyle,
            },
            subtitle: {
              text: ( opkNumber.hasOwnProperty("value") && opkNumber.value!== "" ?("nr OPK "+opkNumber.value ):"" ) +( startData?(" od "+( new Date(startData).getMonth()+1)+"/"+new Date(startData).getFullYear()) : "") +( endData?(" do "+( new Date(endData).getMonth()+1)+"/"+new Date(endData).getFullYear()) : ""), 
              align: 'center',
              margin: 10,
              offsetY: 20,
              floating: false,
              style: titleStyle,
            }
          }

          data.options1.xaxis.categories = categories.map(cur => {
            var iterator = 0
            const splitedItems = cur.trim().split(" ");
            const arrayOfSingleString = [];
            let str = "";
            while (splitedItems.length > 0) {
              const item = splitedItems.shift();
              if (str.length + item.length >= 20) {
                arrayOfSingleString.push(str);
                str = item;
              } else {
                str = str ? `${str} ${item}` : item;
              }
            }
            arrayOfSingleString.push(str);
            return arrayOfSingleString;
          })
          data.options1.yaxis.max = Math.max(...data.series1[0].data)
          if (dataChart1.length > 9) data.options1.chart.height = 500 + (dataChart1.length - 9) * 30

          break;
        case 9:
          data.options = {
            chart: {
              height: 500,
              type: 'scatter',
              zoom: {
                enabled: true,
                type: 'xy'
              }
            },
            xaxis: {
              forceNiceScale: true,
              tickAmount: 10,
              labels: {
                formatter: function(val) {
                  return parseFloat(val).toFixed().toString().replace(".",",")
                }
              },
              title: { text: 'Jednostkowy koszt wytworzenia procedury [zł]' }
            },
            yaxis: {
              tickAmount: 7,
              labels: {
                formatter: function(val) {
                  return parseFloat(val).toFixed()
                }
              },
              title: { text: 'Koszt wykonanych procedur [zł]' }
            },
            legend: {
              show: false
            },
            colors: ['rgb(0,192,209)'],
            tooltip:{
              custom: function({series, seriesIndex, dataPointIndex, w}) {
                let tooltip = '<div class="arrow-box" style="padding: 5px; font-size:10px;">'
                tooltip+='<div style="padding: 3px; font-weight: bold ">'+dataChart[seriesIndex].code
                tooltip+=' - '+dataChart[seriesIndex].name+'</div><div>'
                tooltip+='Liczba wykonanych procedur: '+dataChart[seriesIndex].liczba_proc_us+'<br>'
                tooltip+='Jednostkowy koszt wytworzenia procedury: '+valueConvert(dataChart[seriesIndex].jedn_koszt)+' zł<br>'
                tooltip+='Koszt wykonanych procedur: '+valueConvert(dataChart[seriesIndex].koszt_wykon)+' zł'
                tooltip+= '</div></div>'
                return tooltip
              }
            },
            title: {
              text: "Zestawienie jednostkowych kosztów wytworzenia procedur medycznych ",
              align: 'center',
              margin: 10,
              offsetX: 0,
              offsetY: 0,
              floating: false,
              style: titleStyle,
            },
            subtitle: {
              text: ( opkNumber.hasOwnProperty("value") && opkNumber.value!== "" ?("nr OPK "+opkNumber.value ):"" ) +( startData?(" od "+( new Date(startData).getMonth()+1)+"/"+new Date(startData).getFullYear()) : "") +( endData?(" do "+( new Date(endData).getMonth()+1)+"/"+new Date(endData).getFullYear()) : ""), 
              align: 'center',
              margin: 10,
              offsetY: 20,
              floating: false,
              style: titleStyle,
            }
          }
          data.series = []
        
        dataChart.forEach(item=>{
          if(item.code!=='Wartość ogółem'){
            data.series.push({
              name: item.code,
              data: [[item.jedn_koszt, item.koszt_wykon]]
            })
          }
        })
          break;
        case 10:
          data.series= [{
            data: []
          }, {
            data: []
          }]
          data.options= {
            chart: {
              height: 500,
              type: 'bar',
            },
            plotOptions: {
              bar: {
                horizontal: true,
                dataLabels: {
                  position: 'top',
                  hideOverflowingLabels: false
                },
              }
            },
            dataLabels: {
              enabled: true,
              offsetX: 60,
              style: {...dataLabelStyle, filter:""},
              formatter: function (val) {
              return valueConvert(val) + " zł";
            },
              
              
              formatter: function (val,  opts) {
                return valueConvert(val)+' zł'  ;
              },
            },
            stroke: {
              show: true,
              width: 1,
              colors: ['#fff']
            },
            tooltip: {
              shared: true,
              intersect: false
            },
            xaxis: {
              categories: [],
              title:{ text: 'Koszt'}
            },
            yaxis:{
              show:true,
              // max : 666,
              showAlways:true,
              title:{ text: 'Kod procedury'}
            },
            fill: {colors: ['#26c9d7','rgb(235,107,107)']},
            legend:{
              position: 'top',
              labels: {
                // colors:  ['#00c0d1','#eb6b6b'],
                // useSeriesColors: true
            },

            horizontalAlign: 'left',
            customLegendItems: ["Jednostkowy koszt normatywny procedury",'Jednostkowy koszt wytworzenia procedury'],
            markers: {
              strokeColor: '#fff',
              fillColors: ['#26c9d7','rgb(235,107,107)'],
              radius: 12,
              offsetX: 0,
              offsetY: 0,
              radius:2
          },
            },
             title: {
                text: "Koszty jednostkowe noramtywne i koszty wytworzenia procedur medycznych - porównanie" ,
                align: 'center',
                margin: 10,
                offsetX: 0,
                offsetY: 0,
                floating: false,
                style: titleStyle
              },
              subtitle: {
                text: ( opkNumber.hasOwnProperty("value") && opkNumber.value!== "" ?("nr OPK "+opkNumber.value ):"" ) +( startData?(" od "+( new Date(startData).getMonth()+1)+"/"+new Date(startData).getFullYear()) : "") +( endData?(" do "+( new Date(endData).getMonth()+1)+"/"+new Date(endData).getFullYear()) : ""), 
                align: 'center',
                offsetY: 20,
                floating: false,
                style: titleStyle,
              },
          tooltip:{
            followCursor: true,
            custom: function({series, seriesIndex, dataPointIndex, w}) {
              let txt = ["Jednostkowy koszt normatywny procedury: ",'Jednostkowy koszt wytworzenia procedury: ']
              let name = dataChart.find(element => element.code==categories1[dataPointIndex]).name
              let tooltip = '<div class="arrow-box" style="padding: 5px; font-size:10px;">'
              tooltip+='<div style="padding: 3px; font-weight: bold ">'+name+'</div>'
              tooltip+='<div>'
              tooltip+= txt[0]+valueConvert(series[0][dataPointIndex])+' zł<br>'
              tooltip+=txt[1]+valueConvert(series[1][dataPointIndex])+' zł'
              tooltip+= '</div></div>'
              return tooltip
            }
          }

          }
          var categories1 = []
          var series1 = []
          var series2 =[]
          dataChart.forEach(kod=>{
              categories1.push(kod['code'])
              series1.push(Number(kod['jedn_norm'].toFixed(2)))
              series2.push(Number(kod['jedn_koszt'].toFixed(2)))
          })
          data.options.xaxis.categories = categories1
          data.series[0].data =series1
          data.series[1].data =series2
          var all = series1.concat(series2)
          data.options.yaxis.max =Math.max(...all)
          if(dataChart.length>8) data.options.chart.height = 500 + (dataChart.length-8)*30
          
          break;
        default:
      }
      data.options.chart.toolbar= {
        show: true, 
        tools: {download:{show: true}}
      }
      data.options.chart.export= {
        png: {
          filename: 'Wykres do raportu '+active
        }
      }

    }
    data.options.chart['locales'] = [plApex]
    data.options.chart['defaultLocale'] = "pl"

    return data
  }
  const [chartData, setChartData] = React.useState({series:[],options:{chart:{height:500, type: 'treemap'}}})
  React.useEffect(() => {
    setChartData(getChartData())
  }, [dataChart])

  const checkOverflow = () => {
    if(chartData.series[0].data.length ==0&&!chartData.options1) return ''
    if(chartData.series[0].data.length ==0&&chartData.series1[0].data.length ===0) return ''
    return 'scroll'
  }

    return (<>
      {/* Problem z updatem pomiedzy różnymi typami wykresów
      <ReactApexChart 
        type={chartData.options.chart.type}
        series={chartData.series} 
        options={chartData.options} 
        height={chartData.options.chart.height}/>*/}
        {chartData.options.chart.type==='treemap' && active === 0 && <>{chartData.series.length!==0 ? <ReactApexChart 
          type={chartData.options.chart.type}
          series={chartData.series} 
          options={chartData.options}
          height={chartData.options.chart.height}/>:<>Brak danych</>}</>}
        {chartData.options.chart.type==='bar' && active!==3.1 && active!==10 &&
        <div style={{maxHeight:'750px', overflow: checkOverflow()}}>
          {chartData.series[0].data.length ===0?
            <div style={{...noDataInfo, marginTop: checkOverflow()==''?'200px':'40px', marginBottom: '40px'}}>Brak danych do wyświetlenia</div>:<>
            <ReactApexChart 
            type={chartData.options.chart.type}
            series={chartData.series} 
            options={chartData.options}
            height={chartData.options.chart.height}
          /></>}
          {chartData.options1 && <>
            {chartData.series1[0].data.length ===0?
              <>{chartData.series[0].data.length !==0 && <div style={{...noDataInfo, marginTop: '40px'}}>Brak danych do wyświetlenia</div>}</>:
              <ReactApexChart 
                type={chartData.options1.chart.type}
                series={chartData.series1} 
                options={chartData.options1}
                height={chartData.options1.chart.height}/>
            }
          </>}
          </div>
          }
        {chartData.options.chart.type==='pie'&&<>
          {chartData.series.length ===0?
            <div style={noDataInfo}>Brak danych do wyświetlenia</div>:
            <ReactApexChart 
            type={chartData.options.chart.type}
            series={chartData.series} 
            options={chartData.options}
            height={chartData.options.chart.height}
          />}
        </>}
        {chartData.options.chart.type==='donut'&&<>
          {chartData.series.length ===0?
            <div style={noDataInfo}>Brak danych do wyświetlenia</div>:
            <ReactApexChart 
            type={chartData.options.chart.type}
            series={chartData.series} 
            options={chartData.options}
            height={chartData.options.chart.height}/>}
          {chartData.options1 && <>
            {chartData.series1.length ===0?
              <>{chartData.series.length !==0 && <div style={noDataInfo}>Brak danych do wyświetlenia</div>}</>:
              <ReactApexChart 
                type={chartData.options1.chart.type}
                series={chartData.series1} 
                options={chartData.options1}
                height={chartData.options1.chart.height}/>
            }
          </>}
        </>}
        {chartData.options.chart.type==='line'  && active!==3.2 &&<ReactApexChart 
          type={chartData.options.chart.type}
          series={chartData.series} 
          options={chartData.options}
          height={chartData.options.chart.height}
          />}
        {chartData.options.chart.type==='scatter'&&<>
          {chartData.series.length==0 ? 
            <div style={noDataInfo}>Brak danych do wyświetlenia</div>:
            <ReactApexChart 
            type={chartData.options.chart.type}
            series={chartData.series} 
            options={chartData.options}
            height={chartData.options.chart.height}
            />
          }
        </>}
        {active === 3.1 && chartData.options.chart.type==='bar'&&Object.keys(chartData).includes('series1')&&<>
          {chartData.series[0].data.length!==0 &&<ReactApexChart 
          type={chartData.options.chart.type}
          series={chartData.series} 
          options={chartData.options}
          height={chartData.options.chart.height}/>}
         {chartData.series1[0].data.length!==0 &&<><br></br><br></br><ReactApexChart 
          type={chartData.options.chart.type}
          series={chartData.series1} 
          options={chartData.options1}
          height={chartData.options.chart.height}/>
          </>}
          {chartData.series2[0].data.length!==0 &&<><br></br><br></br><ReactApexChart 
          type={chartData.options.chart.type}
          series={chartData.series2} 
          options={chartData.options2}
          height={chartData.options.chart.height}/>
          </>}
         {chartData.series3[0].data.length!==0 &&<><br></br><br></br><ReactApexChart 
          type={chartData.options.chart.type}
          series={chartData.series3} 
          options={chartData.options3}
          height={chartData.options.chart.height}/></>}
          {chartData.series4[0].data.length!==0 &&<><br></br><br></br><ReactApexChart
          type={chartData.options.chart.type}
          series={chartData.series4} 
          options={chartData.options4}
          height={chartData.options.chart.height}/></>}
          {chartData.series5[0].data.length!==0 &&<><br></br><br></br><ReactApexChart 
          type={chartData.options.chart.type}
          series={chartData.series5} 
          options={chartData.options5}
          height={chartData.options.chart.height}
          /></>}
          {chartData.series6[0].data.length!==0 && <><br></br><br></br><ReactApexChart 
          type={chartData.options.chart.type}
          series={chartData.series6} 
          options={chartData.options6}
          height={chartData.options.chart.height}
          /></>}
          </>}
          {active === 3.2 && chartData.options.chart.type==='line'&&<>
          {chartData.series[0].data.length!==0 &&<ReactApexChart 
          type={chartData.options.chart.type}
          series={chartData.series} 
          options={chartData.options}
          height={chartData.options.chart.height}/>}
         {chartData.series1[0].data.length!==0 &&<><br></br><br></br><ReactApexChart 
          type={chartData.options.chart.type}
          series={chartData.series1} 
          options={chartData.options1}
          height={chartData.options.chart.height}/>
          </>}
          {chartData.series2[0].data.length!==0 &&<><br></br><br></br><ReactApexChart 
          type={chartData.options.chart.type}
          series={chartData.series2} 
          options={chartData.options2}
          height={chartData.options.chart.height}/>
          </>}
         {chartData.series3[0].data.length!==0 &&<><br></br><br></br><ReactApexChart 
          type={chartData.options.chart.type}
          series={chartData.series3} 
          options={chartData.options3}
          height={chartData.options.chart.height}/></>}
          {chartData.series4[0].data.length!==0 &&<><br></br><br></br><ReactApexChart
          type={chartData.options.chart.type}
          series={chartData.series4} 
          options={chartData.options4}
          height={chartData.options.chart.height}/></>}
          {chartData.series5[0].data.length!==0 &&<><br></br><br></br><ReactApexChart 
          type={chartData.options.chart.type}
          series={chartData.series5} 
          options={chartData.options5}
          height={chartData.options.chart.height}
          /></>}
          {chartData.series6[0].data.length!==0 && <><br></br><br></br><ReactApexChart 
          type={chartData.options.chart.type}
          series={chartData.series6} 
          options={chartData.options6}
          height={chartData.options.chart.height}
          /></>}
          </>}
          {active === 10 && chartData.options.chart.type==='bar'?
          <div style={{maxHeight:'750px',maxWidth:'1000px', overflow:'scroll'}}>
        <ReactApexChart 
          type={chartData.options.chart.type}
          series={chartData.series} 
          options={chartData.options}
          height={chartData.options.chart.height}
         /></div>:<div ></div>
          }
      </> 
    )
}
const noDataInfo = {
  textAlign: 'center', 
  marginTop: '200px'
}
export default RaportVisualization
